import { render, staticRenderFns } from "./TemperaturesCard.vue?vue&type=template&id=48d1542c&scoped=true"
import script from "./TemperaturesCard.vue?vue&type=script&lang=js"
export * from "./TemperaturesCard.vue?vue&type=script&lang=js"
import style0 from "./TemperaturesCard.scss?vue&type=style&index=0&id=48d1542c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1542c",
  null
  
)

export default component.exports